import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Breadcrumbs,
  Checkbox,
  Grid,
  Tab,
  Tabs,
  Tooltip,
  Typography,
  Radio,
  FormControlLabel,
  RadioGroup,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import { MandatoryField } from "../../common/MandatoryFieldsIcon/MandatoryField";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useFormik } from "formik";
import { VendorIntegrationSolutionSchema } from "../../common/ValidationSchema/ValidationSchema";
import FooterButtons from "../../common/FooterButtons/FooterButtons";
import ApiServices from "../../services/ApiServices";
import { useLoading } from "../../hooks/useLoader";
import {
  VENDOR,
  VENDOR_INTEGRATIONSOLUTION,
  MASTER_DATA,
  ADMIN_MANAGE_SUBSCRIBER_LIST,
  ADMIN_MANAGE_SUBSCRIBER_TOGGLE_ACCESS,
} from "../../constants/api-constants";
import { toast } from "react-toastify";
import { MenuListItems } from "../../common/Sidebar/MenuListItems";
import { SystemModulesEnum } from "../../constants/SystemUsers";
import {
  childModulePermissions,
  PermissionEnum,
} from "../../constants/permissionService";

import { useAuth } from "../../hooks/useAuth";
import { v4 as uuidv4 } from "uuid";
import TabPanel from "../../common/TabPanel/TabPanel";
import { a11yProps } from "../../common/TabPanel/a11yProps";
import DataTable from "../Tables/DataTable/DataTable";
import { COLUMN_TYPES, TABS } from "../../constants/common";
import IntServiceList from "./IntServiceList";
import "../Vendors/AddEditVendor.css";
import "../Vendors/Vendors.css";
import "./IntSolution.css";

const SOLUTION_TYPE = {
  THIRD_PARTY: 1,
  INCHANTED: 2,
};

const INTEGRATION_TYPE = {
  API_KEY: 3,
  BASIC: 1,
  JWT: 2,
};

const INCHANTED_ADDINS = [
  "IRMI Glossary of Terms",
  "Share Using Inchanted",
  "Reusable Link",
  "Apryse",
];

const BASIC_JWT_INFO_MESSAGE =
  "Additional configuration may be required at Enterprise or End User level.";

const getAdminManageSubscriberList = (integrationSolutionId, query) => {
  const payload = {
    pageNumber: Number(query.PageNumber) || 1,
    pageSize: Number(query.PageSize) || 10,
    sortColumn: query.SortColumn || "FIRSTNAME",
    sortType: query.SortType || "ASC",
    filter: {
      searchText: query.searchText || "",
    },
  };

  return ApiServices.httpPost(
    ADMIN_MANAGE_SUBSCRIBER_LIST(integrationSolutionId),
    payload,
  );
};

const updateAdminManageSubscriberAccess = (addInId, payload) => {
  return ApiServices.httpPut(
    ADMIN_MANAGE_SUBSCRIBER_TOGGLE_ACCESS(addInId),
    payload,
  );
};

const mapSubscriberRecords = (records) => {
  return records.map((record) => ({
    ...record,
    contentSubscriberId: record.subscriberId,
    associateFrom: record.fromDate,
    associateTo: record.toDate,
    contentSubscriberStatus: Boolean(record.hasAccess),
    egBrandName: record.enterpriseGroupName,
  }));
};

/*istanbul ignore next */
const AddEditIntSolution = () => {
  const { vendorId, solutionId, mode } = useParams();
  const history = useHistory();
  const auth = useAuth();
  const { showLoader } = useLoading();
  const permissionId = auth.getPermissionId();

  const [isEditMode, setIsEditMode] = useState(mode !== "view");
  const [activeTab, setActiveTab] = useState("basicInfo");
  const [expanded, setExpanded] = useState(
    mode === "services" ? "panel2" : "panel1",
  );
  const [shouldOpenServiceModal, setShouldOpenServiceModal] = useState(false);
  const subscribersSearchTimerRef = useRef(null);

  // Manage Subscribers state
  const [subscribersTable, setSubscribersTable] = useState([]);
  const [subscribersTotalPages, setSubscribersTotalPages] = useState(0);
  const [subscribersPageSize, setSubscribersPageSize] = useState(0);
  const [subscribersSelectedColumns, setSubscribersSelectedColumns] = useState(
    [],
  );
  const [subscribersQuery, setSubscribersQuery] = useState({
    searchText: "",
    SortType: "ASC",
    SortColumn: "FIRSTNAME",
    PageNumber: 1,
    PageSize: 10,
    Filter: {
      searchText: "",
    },
  });

  const [vendor, setVendor] = useState({
    name: "",
    email: "",
    secondaryEmail: "",
    phoneNumber: "",
  });

  const [solutionType, setSolutionType] = useState(0);
  const [integrationType, setIntegrationType] = useState(0);
  const [inchantedAddinType, setInchantedAddinType] = useState(0);
  const [apiKeyList, setApiKeyList] = useState([]);

  const [solutionTypeOptions, setSolutionTypeOptions] = useState([
    { key: SOLUTION_TYPE.THIRD_PARTY, value: "Third Party" },
    { key: SOLUTION_TYPE.INCHANTED, value: "Inchanted" },
  ]);
  const [integrationTypeOptions, setIntegrationTypeOptions] = useState([
    { key: INTEGRATION_TYPE.API_KEY, value: "API Key" },
    { key: INTEGRATION_TYPE.BASIC, value: "Basic" },
    { key: INTEGRATION_TYPE.JWT, value: "JWT" },
  ]);
  const [addToOptions, setAddToOptions] = useState([
    { key: 1, value: "Header" },
    { key: 2, value: "Query Parameter" },
  ]);
  const [inchantedAddinOptions, setInchantedAddinOptions] = useState(
    INCHANTED_ADDINS.map((value, index) => ({ key: index + 1, value })),
  );

  let vendorContactModuleId = MenuListItems.find(
    (item) => item.name === SystemModulesEnum.VENDORS,
  )?.moduleId;
  const vendorIntSolutionPermission =
    childModulePermissions(
      vendorContactModuleId,
      SystemModulesEnum.VENDOR_INTEGRATION_SOLUTION,
    ) || [];

  const vendorSolutionInit = {
    name: "",
    description: "",
    vendorId: Number(vendorId),
    status: 1,
    solutionType: 0,
    integrationType: 0,
    inchantedAddinType: 0,
    integrationTypeAPIKeyList: [],
  };

  const formik = useFormik({
    initialValues: vendorSolutionInit,
    enableReinitialize: true,
    validationSchema: VendorIntegrationSolutionSchema,
  });

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const SUBSCRIBER_COLUMNS = [
    {
      fieldName: "firstName",
      label: "First Name",
      isSelected: true,
      type: COLUMN_TYPES.BASIC,
      showInSelection: true,
      width: 130,
      sort: true,
      sortBy: "FIRSTNAME",
    },
    {
      fieldName: "lastName",
      label: "Last Name",
      isSelected: true,
      type: COLUMN_TYPES.BASIC,
      showInSelection: true,
      width: 130,
      sort: true,
      sortBy: "LASTNAME",
    },
    {
      fieldName: "email",
      label: "Email Address",
      isSelected: true,
      type: COLUMN_TYPES.EMAIL,
      showInSelection: true,
      width: 200,
      sort: false,
      sortBy: "EMAIL",
    },
    {
      fieldName: "associateFrom",
      label: "From",
      isSelected: true,
      type: COLUMN_TYPES.DATE,
      showInSelection: true,
      width: 120,
      sort: false,
      sortBy: "FROMDATE",
    },
    {
      fieldName: "associateTo",
      label: "To",
      isSelected: true,
      type: COLUMN_TYPES.DATE,
      showInSelection: true,
      width: 120,
      sort: false,
      sortBy: "TODATE",
    },
    {
      fieldName: "contentSubscriberStatus",
      label: "Associated",
      isSelected: true,
      type: COLUMN_TYPES.STATUS_CHANGE,
      showInSelection: true,
      activeLabelText: "Yes",
      inactiveLabelText: "No",
      width: 110,
      sort: false,
      sortBy: "HASACCESS",
    },
    {
      fieldName: "status",
      label: "Status",
      isSelected: true,
      type: COLUMN_TYPES.ACTIVE_INACTIVE_LABEL,
      showInSelection: true,
      activeLabelText: "Active",
      inactiveLabelText: "Inactive",
      cssClass: "status-change",
      width: 100,
      sort: false,
      sortBy: "STATUS",
    },
    {
      fieldName: "egBrandName",
      label: "Enterprise Group",
      isSelected: true,
      type: COLUMN_TYPES.BASIC,
      showInSelection: true,
      width: 160,
      sort: false,
      sortBy: "ENTERPRISEGROUPNAME",
    },
  ];

  const loadSubscribersColumns = () => {
    const selectedCols = localStorage.getItem("selectedColumns")
      ? JSON.parse(localStorage.getItem("selectedColumns"))
      : null;
    const cols = selectedCols?.intSolutionSubscribers;
    setSubscribersSelectedColumns(cols || SUBSCRIBER_COLUMNS);
  };

  const loadSubscribers = async () => {
    if (!solutionId || solutionId === "new") {
      setSubscribersTable([]);
      setSubscribersTotalPages(0);
      setSubscribersPageSize(subscribersQuery.PageSize);
      return;
    }
    try {
      showLoader(true);
      const data = await getAdminManageSubscriberList(
        solutionId,
        subscribersQuery,
      );
      showLoader(false);
      if (data?.responseStatus?.isSuccess) {
        const result = data?.result || {};
        const records = Array.isArray(result.records) ? result.records : [];
        setSubscribersTable(mapSubscriberRecords(records));
        setSubscribersTotalPages(result.totalPages || 0);
        setSubscribersPageSize(result.pageSize || subscribersQuery.PageSize);
      } else {
        toast.error(
          data?.responseStatus?.error || "Failed to load subscribers.",
        );
        setSubscribersTable([]);
        setSubscribersTotalPages(0);
        setSubscribersPageSize(subscribersQuery.PageSize);
      }
    } catch {
      showLoader(false);
      toast.error("Failed to load subscribers.");
      setSubscribersTable([]);
      setSubscribersTotalPages(0);
      setSubscribersPageSize(subscribersQuery.PageSize);
    }
  };

  const subscribersOnSearchHandler = (event) => {
    const searchText = event.target.value;

    if (subscribersSearchTimerRef.current) {
      clearTimeout(subscribersSearchTimerRef.current);
    }

    subscribersSearchTimerRef.current = setTimeout(() => {
      setSubscribersQuery((prev) => ({
        ...prev,
        PageNumber: 1,
        searchText,
        Filter: {
          ...prev.Filter,
          searchText,
        },
      }));
    }, 1000);
  };

  const subscribersSortHandler = (sortOrder, sortBy) => {
    setSubscribersQuery((prev) => {
      if (prev.SortColumn === sortBy) {
        return { ...prev, SortType: sortOrder === "ASC" ? "DESC" : "ASC" };
      }
      return { ...prev, SortColumn: sortBy, SortType: "ASC" };
    });
  };

  const subscribersHandleChangePageNumber = (event, newPage) => {
    setSubscribersQuery((prev) => ({ ...prev, PageNumber: newPage }));
  };

  const subscribersPageSizeChangeHandler = (PageSize) => {
    setSubscribersQuery((prev) => ({ ...prev, PageSize, PageNumber: 1 }));
  };

  const handleSubscriberAccessToggle = async (
    fieldName,
    userId,
    status,
    event,
    row,
  ) => {
    const subscriberId = row?.subscriberId || userId;
    const addInId = row?.addInId;
    const hasAccess = event?.target?.checked ?? !status;

    if (!addInId) {
      toast.error("Add-in id is missing for selected subscriber.");
      return;
    }

    try {
      showLoader(true);
      const response = await updateAdminManageSubscriberAccess(addInId, {
        subscriberId,
        hasAccess,
      });
      showLoader(false);

      if (!response?.responseStatus?.isSuccess) {
        toast.error(
          response?.responseStatus?.error ||
            "Failed to update subscriber access.",
        );
        return;
      }

      toast.success(
        response?.responseStatus?.description ||
          "Subscriber access updated successfully.",
      );

      await loadSubscribers();
    } catch {
      showLoader(false);
      toast.error("Failed to update subscriber access.");
    }
  };

  useEffect(() => {
    loadVendorDetails();
    loadDropdownOptions();
    loadSubscribersColumns();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (solutionId && solutionId !== "new") {
      loadSolutionDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [solutionId]);

  useEffect(() => {
    if (activeTab === "manageSubscribers") {
      loadSubscribers();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, subscribersQuery]);

  useEffect(() => {
    return () => {
      if (subscribersSearchTimerRef.current) {
        clearTimeout(subscribersSearchTimerRef.current);
      }
    };
  }, []);

  const loadVendorDetails = async () => {
    try {
      showLoader(true);
      const data = await ApiServices.httpGet(`${VENDOR}/${vendorId}`);
      showLoader(false);
      if (data?.result) {
        setVendor({
          name: data.result.name || "",
          email: data.result.email || "",
          secondaryEmail: data.result.secondaryEmail || "",
          phoneNumber: data.result.phoneNumber || "",
        });
      }
    } catch {
      showLoader(false);
    }
  };

  const loadDropdownOptions = async () => {
    try {
      const url = `${MASTER_DATA}?include=enumMasterData`;
      const response = await ApiServices.httpGet(url);
      const enumMasterData = response?.result?.enumMasterData || {};
      if (
        Array.isArray(enumMasterData.integrationSolutionTypes) &&
        enumMasterData.integrationSolutionTypes.length > 0
      ) {
        setSolutionTypeOptions(enumMasterData.integrationSolutionTypes);
      }
      if (
        Array.isArray(enumMasterData.integrationTypes) &&
        enumMasterData.integrationTypes.length > 0
      ) {
        setIntegrationTypeOptions(enumMasterData.integrationTypes);
      }
      if (
        Array.isArray(enumMasterData.addRequestTos) &&
        enumMasterData.addRequestTos.length > 0
      ) {
        setAddToOptions(enumMasterData.addRequestTos);
      }
      if (
        Array.isArray(enumMasterData.inchantedAddinTypes) &&
        enumMasterData.inchantedAddinTypes.length > 0
      ) {
        setInchantedAddinOptions(enumMasterData.inchantedAddinTypes);
      }
    } catch {
      // ignore: dropdown options will fall back to defaults
    }
  };

  const loadSolutionDetails = async () => {
    try {
      showLoader(true);
      const data = await ApiServices.httpGet(
        `${VENDOR_INTEGRATIONSOLUTION}/${solutionId}`,
      );
      showLoader(false);
      const result = data?.result || {};
      const resolvedInchantedAddinType = Number.isFinite(
        Number(result.inchantedAddinType),
      )
        ? Number(result.inchantedAddinType)
        : 0;
      formik.setValues({
        ...result,
        inchantedAddinType: resolvedInchantedAddinType,
      });
      setSolutionType(result.solutionType || 0);
      setIntegrationType(result.integrationType || 0);
      setInchantedAddinType(resolvedInchantedAddinType);
      const apiKeys = (data.result.integrationTypeAPIKeyList || []).map(
        (item) => {
          let hasKeyValue = false;
          if (typeof item.hasKeyValue === "boolean") {
            hasKeyValue = item.hasKeyValue;
          } else if (typeof item.isKeyValue === "boolean") {
            hasKeyValue = item.isKeyValue;
          } else if (typeof item.hasValue === "boolean") {
            hasKeyValue = item.hasValue;
          }
          return { ...item, hasKeyValue };
        },
      );
      setApiKeyList(apiKeys);
      formik.setFieldValue("integrationTypeAPIKeyList", apiKeys);
    } catch {
      showLoader(false);
    }
  };

  const handleSolutionTypeChange = (event) => {
    const nextSolutionType = Number(event.target.value);
    setSolutionType(nextSolutionType);
    formik.setFieldValue("solutionType", nextSolutionType);
    if (nextSolutionType === SOLUTION_TYPE.THIRD_PARTY) {
      setIntegrationType(INTEGRATION_TYPE.API_KEY);
      formik.setFieldValue("integrationType", INTEGRATION_TYPE.API_KEY);
      const initialApiKey = [
        {
          uuid: uuidv4(),
          hasKeyValue: false,
          keyName: "",
          userLabel: "",
          keyValue: "",
          addTo: 0,
        },
      ];
      setApiKeyList(initialApiKey);
      formik.setFieldValue("integrationTypeAPIKeyList", initialApiKey);
      setInchantedAddinType(0);
      formik.setFieldValue("inchantedAddinType", 0);
    } else if (nextSolutionType === SOLUTION_TYPE.INCHANTED) {
      setIntegrationType(0);
      formik.setFieldValue("integrationType", 0);
      setApiKeyList([]);
      formik.setFieldValue("integrationTypeAPIKeyList", []);
    } else {
      setIntegrationType(0);
      formik.setFieldValue("integrationType", 0);
      setApiKeyList([]);
      formik.setFieldValue("integrationTypeAPIKeyList", []);
      setInchantedAddinType(0);
      formik.setFieldValue("inchantedAddinType", 0);
    }
  };

  const handleIntegrationTypeChange = (event) => {
    const nextIntegrationType = Number(event.target.value);
    setIntegrationType(nextIntegrationType);
    formik.setFieldValue("integrationType", nextIntegrationType);
    if (nextIntegrationType === INTEGRATION_TYPE.API_KEY) {
      const initialApiKey = [
        {
          uuid: uuidv4(),
          hasKeyValue: false,
          keyName: "",
          userLabel: "",
          keyValue: "",
          addTo: 0,
        },
      ];
      setApiKeyList(initialApiKey);
      formik.setFieldValue("integrationTypeAPIKeyList", initialApiKey);
    } else {
      setApiKeyList([]);
      formik.setFieldValue("integrationTypeAPIKeyList", []);
    }
  };

  const goBackToList = () => {
    history.push(`/vendor/${vendorId}`);
  };

  const onCancelHandler = () => {
    goBackToList();
  };

  const onEditHandler = () => {
    setIsEditMode(true);
    history.replace(`/vendor/${vendorId}/solution/${solutionId}/edit`);
  };

  const saveSolution = async (isNext) => {
    try {
      const payload = {
        ...formik.values,
        integrationTypeAPIKeyList: apiKeyList,
      };
      if (payload.solutionType === SOLUTION_TYPE.INCHANTED)
        delete payload.integrationType;
      delete payload.inchantedAddin;
      showLoader(true);
      const response = await ApiServices.httpPost(
        VENDOR_INTEGRATIONSOLUTION,
        payload,
      );
      showLoader(false);
      if (response.responseStatus.isSuccess) {
        toast.success(response.responseStatus.description);
        if (isNext) {
          history.push(
            `/vendor/${vendorId}/solution/${response.result.integrationSolutionId}/edit`,
          );
        } else {
          goBackToList();
        }
      } else {
        toast.error(response.responseStatus.error);
      }
    } catch {
      showLoader(false);
      toast.error("Internal server error");
    }
  };

  const updateSolution = async (isNext) => {
    try {
      const payload = {
        ...formik.values,
        integrationTypeAPIKeyList: apiKeyList,
      };
      if (payload.solutionType === SOLUTION_TYPE.INCHANTED)
        delete payload.integrationType;
      delete payload.inchantedAddin;
      showLoader(true);
      const response = await ApiServices.httpPut(
        VENDOR_INTEGRATIONSOLUTION,
        payload,
      );
      showLoader(false);
      if (response.responseStatus.isSuccess) {
        formik.setValues(response.result);
        toast.success(response.responseStatus.description);
        if (isNext) {
          setExpanded("panel2");
          setShouldOpenServiceModal(true);
          history.replace(
            `/vendor/${vendorId}/solution/${solutionId}/services`,
          );
        } else {
          goBackToList();
        }
      } else {
        toast.error(response.responseStatus.error);
      }
    } catch {
      showLoader(false);
      toast.error("Internal server error");
    }
  };

  const isNewSolution = !solutionId || solutionId === "new";

  return (
    <div className="approval-container">
      <div className="approval-basic-details">
        <Breadcrumbs
          separator="›"
          aria-label="breadcrumb"
          className="distributor-breadcrumbs"
        >
          <Link to="/vendors" className="breadcrumb-title">
            Vendors
          </Link>
          <Link
            to={`/vendor/${vendorId}`}
            className="breadcrumb-title"
            onClick={(e) => {
              e.preventDefault();
              goBackToList();
            }}
          >
            Integration Solutions
          </Link>
          <Typography color="text.primary" className="breadcrumb-title">
            Solution Details
          </Typography>
          <Typography color="text.primary" className="content-last">
            Basic Information
          </Typography>
        </Breadcrumbs>
      </div>

      <Grid container spacing={2} paddingLeft={4}>
        <Grid item xs={3} p={2}>
          <div>Vendor Name</div>
          <div className="approval-basic-info">{vendor.name || "—"}</div>
        </Grid>
        <Grid item xs={3} p={2}>
          <div>Primary Email Address</div>
          <div
            className="approval-basic-info"
            style={{ lineBreak: "anywhere", overflow: "hidden" }}
          >
            {vendor.email || "—"}
          </div>
        </Grid>
        <Grid item xs={3} p={2}>
          <div>Secondary Email Address</div>
          <div
            className="approval-basic-info"
            style={{ lineBreak: "anywhere", overflow: "hidden" }}
          >
            {vendor.secondaryEmail || "—"}
          </div>
        </Grid>
        <Grid item xs={3} p={2}>
          <div>Phone Number</div>
          <div
            className="approval-basic-info"
            style={{ lineBreak: "anywhere", overflow: "hidden" }}
          >
            {vendor.phoneNumber || "—"}
          </div>
        </Grid>
      </Grid>

      <Grid container spacing={0} paddingLeft={4} marginTop={2}>
        <Grid item md={9} lg={11} sm={12} xs={12}>
          <Box
            p={1}
            className="right-section-vendor"
            sx={{ borderBottom: 1, borderColor: "divider" }}
          >
            <Tabs value={activeTab} onChange={(e, v) => setActiveTab(v)}>
              <Tab
                className="my-tabs"
                label="Basic Information"
                value="basicInfo"
                {...a11yProps("intSol", "basicInfo")}
              />
              <Tab
                className="my-tabs"
                label="Manage Subscribers"
                value="manageSubscribers"
                {...a11yProps("intSol", "manageSubscribers")}
              />
            </Tabs>

            <TabPanel
              value={activeTab}
              index="basicInfo"
              className="distributor-tab-panel"
            >
              <form>
                <div className="parent-div-accord">
                  <Accordion
                    className="accordion-ent"
                    expanded={expanded === "panel1"}
                    onChange={handleChange("panel1")}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography sx={{ fontWeight: 700 }}>
                        Basic Details
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid
                        container
                        padding={2}
                        className="blue-field-section"
                      >
                        <Grid
                          container
                          padding={0}
                          sx={{ background: "white" }}
                        >
                          <Grid item xs={12} p={2}>
                            <label
                              htmlFor="name"
                              style={{ display: "block", marginBottom: "4px" }}
                            >
                              Solution Name <MandatoryField />
                            </label>
                            <input
                              id="name"
                              name="name"
                              className="form-label form-control"
                              type="text"
                              placeholder="Enter Solution Name"
                              style={{ width: "100%" }}
                              value={formik.values?.name}
                              onChange={(e) => {
                                if (
                                  !formik.values?.name &&
                                  e.target.value === " "
                                )
                                  return;
                                formik.setFieldValue("dirty", true);
                                formik.handleChange(e);
                              }}
                              disabled={!isEditMode}
                            />
                          </Grid>

                          <Grid item xs={12} p={2}>
                            <label
                              htmlFor="description"
                              style={{ display: "block", marginBottom: "4px" }}
                            >
                              Description <MandatoryField />
                            </label>
                            <textarea
                              id="description"
                              name="description"
                              className="form-label form-control bs-cus scrollable-input-content"
                              placeholder="Add Description"
                              value={formik.values?.description}
                              onChange={(e) => {
                                if (
                                  !formik.values?.description &&
                                  e.target.value === " "
                                )
                                  return;
                                formik.setFieldValue("dirty", true);
                                formik.handleChange(e);
                              }}
                              disabled={!isEditMode}
                            />
                          </Grid>

                          <Grid item xs={6} p={2}>
                            <label
                              htmlFor="solutionType"
                              style={{ display: "block", marginBottom: "4px" }}
                            >
                              Solution Type <MandatoryField />
                            </label>
                            <select
                              id="solutionType"
                              name="solutionType"
                              className="form-label form-control"
                              style={{ width: "100%" }}
                              disabled={!isEditMode}
                              value={solutionType}
                              onChange={handleSolutionTypeChange}
                            >
                              <option disabled value={0}>
                                Select Solution Type
                              </option>
                              {solutionTypeOptions.map((option) => (
                                <option key={option.key} value={option.key}>
                                  {option.value}
                                </option>
                              ))}
                            </select>
                          </Grid>

                          {solutionType === SOLUTION_TYPE.THIRD_PARTY && (
                            <Grid item xs={6} p={2}>
                              <label
                                htmlFor="integrationType"
                                style={{
                                  display: "block",
                                  marginBottom: "4px",
                                }}
                              >
                                Integration Type <MandatoryField />
                              </label>
                              <select
                                id="integrationType"
                                name="integrationType"
                                className="form-label form-control"
                                style={{ width: "100%" }}
                                disabled={!isEditMode}
                                value={integrationType}
                                onChange={handleIntegrationTypeChange}
                              >
                                <option disabled value={0}>
                                  Select Integration Type
                                </option>
                                {integrationTypeOptions.map((option) => (
                                  <option key={option.key} value={option.key}>
                                    {option.value}
                                  </option>
                                ))}
                              </select>
                            </Grid>
                          )}

                          {solutionType === SOLUTION_TYPE.THIRD_PARTY &&
                            (integrationType === INTEGRATION_TYPE.BASIC ||
                              integrationType === INTEGRATION_TYPE.JWT) && (
                              <Grid item xs={12} p={2}>
                                <Typography
                                  sx={{
                                    color: "#666",
                                    fontStyle: "italic",
                                    fontSize: "0.9rem",
                                  }}
                                >
                                  {BASIC_JWT_INFO_MESSAGE}
                                </Typography>
                              </Grid>
                            )}

                          {solutionType === SOLUTION_TYPE.THIRD_PARTY &&
                            integrationType === INTEGRATION_TYPE.API_KEY && (
                              <>
                                {apiKeyList.map((apiKey, index) => (
                                  <React.Fragment
                                    key={apiKey.uuid || `${index}-api-key`}
                                  >
                                    <Grid
                                      container
                                      spacing={1}
                                      margin={0}
                                      alignItems="center"
                                      sx={{ mt: index === 0 ? 1 : 2, mb: 0.5 }}
                                    >
                                      <Grid
                                        item
                                        xs={12}
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          ml: 1.5,
                                        }}
                                      >
                                        <Checkbox
                                          id={`isKeyValue_${index}`}
                                          name={`isKeyValue_${index}`}
                                          checked={!!apiKey.hasKeyValue}
                                          disabled={!isEditMode}
                                          onChange={(e) => {
                                            const updatedKeys = [...apiKeyList];
                                            updatedKeys[index].hasKeyValue =
                                              e.target.checked;
                                            if (!e.target.checked)
                                              updatedKeys[index].keyValue = "";
                                            setApiKeyList(updatedKeys);
                                            formik.setFieldValue(
                                              "integrationTypeAPIKeyList",
                                              updatedKeys,
                                            );
                                          }}
                                          sx={{ p: 0.5, mr: 1 }}
                                        />
                                        <Typography sx={{ fontWeight: 100 }}>
                                          Key Value Mapping
                                        </Typography>
                                      </Grid>
                                    </Grid>

                                    <Grid
                                      container
                                      spacing={1}
                                      margin={0}
                                      alignItems="center"
                                      sx={{ mb: 1, px: 2 }}
                                    >
                                      <Grid item xs={2.8}>
                                        <span>Key Name</span>
                                        <MandatoryField />
                                        <input
                                          id={`keyName_${index}`}
                                          name={`keyName_${index}`}
                                          className="form-label form-control"
                                          type="text"
                                          placeholder="Enter Key Name"
                                          style={{ width: "100%" }}
                                          value={apiKey.keyName}
                                          disabled={!isEditMode}
                                          onChange={(e) => {
                                            const updatedKeys = [...apiKeyList];
                                            updatedKeys[index].keyName =
                                              e.target.value;
                                            setApiKeyList(updatedKeys);
                                            formik.setFieldValue(
                                              "integrationTypeAPIKeyList",
                                              updatedKeys,
                                            );
                                          }}
                                        />
                                      </Grid>
                                      <Grid item xs={2.6}>
                                        <span>User Label</span>
                                        <input
                                          id={`userLabel_${index}`}
                                          name={`userLabel_${index}`}
                                          className="form-label form-control"
                                          type="text"
                                          placeholder="User Label"
                                          style={{ width: "100%" }}
                                          value={apiKey.userLabel || ""}
                                          disabled={!isEditMode}
                                          onChange={(e) => {
                                            const updatedKeys = [...apiKeyList];
                                            updatedKeys[index].userLabel =
                                              e.target.value;
                                            setApiKeyList(updatedKeys);
                                            formik.setFieldValue(
                                              "integrationTypeAPIKeyList",
                                              updatedKeys,
                                            );
                                          }}
                                        />
                                      </Grid>
                                      <Grid item xs={2.6}>
                                        <span>Key Value</span>
                                        <MandatoryField />
                                        <input
                                          id={`keyValue_${index}`}
                                          name={`keyValue_${index}`}
                                          className="form-label form-control"
                                          type="text"
                                          placeholder="Enter Key Value"
                                          style={{ width: "100%" }}
                                          value={apiKey.keyValue}
                                          disabled={
                                            !isEditMode || !apiKey.hasKeyValue
                                          }
                                          onChange={(e) => {
                                            const updatedKeys = [...apiKeyList];
                                            updatedKeys[index].keyValue =
                                              e.target.value;
                                            setApiKeyList(updatedKeys);
                                            formik.setFieldValue(
                                              "integrationTypeAPIKeyList",
                                              updatedKeys,
                                            );
                                          }}
                                        />
                                      </Grid>
                                      <Grid item xs={2.5}>
                                        <span>Add to</span>
                                        <MandatoryField />
                                        <select
                                          id={`addTo_${index}`}
                                          name={`addTo_${index}`}
                                          className="form-label form-control"
                                          style={{ width: "100%" }}
                                          disabled={!isEditMode}
                                          value={apiKey.addTo}
                                          onChange={(e) => {
                                            const updatedKeys = [...apiKeyList];
                                            updatedKeys[index].addTo = Number(
                                              e.target.value,
                                            );
                                            setApiKeyList(updatedKeys);
                                            formik.setFieldValue(
                                              "integrationTypeAPIKeyList",
                                              updatedKeys,
                                            );
                                          }}
                                        >
                                          <option disabled value={0}>
                                            Select Add To
                                          </option>
                                          {addToOptions.map((option) => (
                                            <option
                                              key={option.key}
                                              value={option.key}
                                            >
                                              {option.value}
                                            </option>
                                          ))}
                                        </select>
                                      </Grid>
                                      {isEditMode && (
                                        <Grid
                                          item
                                          xs={0.5}
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "flex-start",
                                          }}
                                        >
                                          {index === apiKeyList.length - 1 && (
                                            <Tooltip
                                              placement="bottom"
                                              title="Add New Parameter"
                                            >
                                              <AddOutlinedIcon
                                                sx={{
                                                  cursor: "pointer",
                                                  color: "#1aaefa",
                                                }}
                                                onClick={() => {
                                                  const updatedKeys = [
                                                    ...apiKeyList,
                                                    {
                                                      uuid: uuidv4(),
                                                      hasKeyValue: false,
                                                      keyName: "",
                                                      userLabel: "",
                                                      keyValue: "",
                                                      addTo: 0,
                                                    },
                                                  ];
                                                  setApiKeyList(updatedKeys);
                                                  formik.setFieldValue(
                                                    "integrationTypeAPIKeyList",
                                                    updatedKeys,
                                                  );
                                                }}
                                              />
                                            </Tooltip>
                                          )}
                                          {index !== 0 && (
                                            <Tooltip
                                              placement="top"
                                              title="Delete Parameter"
                                            >
                                              <DeleteOutlineIcon
                                                sx={{
                                                  cursor: "pointer",
                                                  color: "red",
                                                  marginLeft: "6px",
                                                }}
                                                onClick={() => {
                                                  const updatedKeys =
                                                    apiKeyList.filter(
                                                      (_, i) => i !== index,
                                                    );
                                                  setApiKeyList(updatedKeys);
                                                  formik.setFieldValue(
                                                    "integrationTypeAPIKeyList",
                                                    updatedKeys,
                                                  );
                                                }}
                                              />
                                            </Tooltip>
                                          )}
                                        </Grid>
                                      )}
                                    </Grid>
                                  </React.Fragment>
                                ))}
                              </>
                            )}

                          {solutionType === SOLUTION_TYPE.INCHANTED && (
                            <Grid item xs={12} p={2}>
                              <RadioGroup
                                name="inchantedAddinType"
                                value={inchantedAddinType || 0}
                                onChange={(e) => {
                                  const nextValue = Number(e.target.value);
                                  setInchantedAddinType(nextValue);
                                  formik.setFieldValue(
                                    "inchantedAddinType",
                                    nextValue,
                                  );
                                }}
                              >
                                {inchantedAddinOptions.map((option) => (
                                  <FormControlLabel
                                    key={option.key}
                                    value={option.key}
                                    disabled={!isEditMode}
                                    control={<Radio size="small" />}
                                    label={option.value}
                                    sx={{
                                      margin: 0,
                                      alignItems: "center",
                                      "& .MuiFormControlLabel-label": {
                                        whiteSpace: "nowrap",
                                      },
                                    }}
                                  />
                                ))}
                              </RadioGroup>
                            </Grid>
                          )}
                        </Grid>
                      </Grid>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          marginTop: "16px",
                        }}
                      >
                        <FooterButtons
                          isEditMode={isEditMode}
                          permissions={vendorIntSolutionPermission}
                          permissionId={permissionId}
                          editPermission={
                            !isNewSolution &&
                            vendorIntSolutionPermission.includes(
                              PermissionEnum.UPDATE,
                            )
                          }
                          showUpdateNext={
                            !isNewSolution &&
                            solutionType !== SOLUTION_TYPE.INCHANTED
                          }
                          showSaveNext={
                            isNewSolution &&
                            solutionType !== SOLUTION_TYPE.INCHANTED
                          }
                          disableUpdateNext={!isEditMode || !formik.isValid}
                          disableSaveNext={!isEditMode || !formik.isValid}
                          showUpdateDetail={!isNewSolution}
                          disableUpdateDetail={!isEditMode || !formik.isValid}
                          disableSaveDetail={!isEditMode || !formik.isValid}
                          onCancel={onCancelHandler}
                          onEdit={onEditHandler}
                          onUpdateNext={() => updateSolution(true)}
                          onSaveNext={() => saveSolution(true)}
                          onUpdate={() => updateSolution(false)}
                          onSave={() => saveSolution(false)}
                          buttonType="button"
                        />
                      </div>
                    </AccordionDetails>
                  </Accordion>

                  {solutionType !== SOLUTION_TYPE.INCHANTED && (
                    <Accordion
                      className="accordion-ent"
                      expanded={expanded === "panel2"}
                      onChange={handleChange("panel2")}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2a-content"
                        id="panel2a-header"
                      >
                        <Typography sx={{ fontWeight: 700 }}>
                          Service Details
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails
                        style={{
                          maxHeight: "100vh",
                          overflowY: "auto",
                          marginBottom: "50px",
                        }}
                      >
                        {!isNewSolution && (
                          <IntServiceList
                            selectedSubTab={TABS.VENDOR_SERVICES}
                            vendorId={Number(vendorId)}
                            integrationSolutionId={Number(solutionId)}
                            shouldOpenServiceModal={shouldOpenServiceModal}
                            setShouldOpenServiceModal={
                              setShouldOpenServiceModal
                            }
                            hideSolutionBasicDetails
                            onCancel={() => {
                              setShouldOpenServiceModal(false);
                            }}
                          />
                        )}
                      </AccordionDetails>
                    </Accordion>
                  )}
                </div>
              </form>
            </TabPanel>

            <TabPanel
              value={activeTab}
              index="manageSubscribers"
              className="distributor-tab-panel"
            >
              <Grid container spacing={0}>
                <Grid item xs={12} sx={{ mb: 1 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, fontSize: "1rem" }}
                  >
                    Manage Subscribers for {formik.values?.name || ""}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <DataTable
                    uniqueKey="subscriberId"
                    query={subscribersQuery}
                    columns={subscribersSelectedColumns}
                    adminTable={subscribersTable}
                    onSearch={subscribersOnSearchHandler}
                    onSort={subscribersSortHandler}
                    onPageSizeChange={subscribersPageSizeChangeHandler}
                    handleChangePage={subscribersHandleChangePageNumber}
                    totalPages={subscribersTotalPages}
                    pageSize={subscribersPageSize}
                    page={subscribersQuery.PageNumber}
                    showToggle={true}
                    onToggle={handleSubscriberAccessToggle}
                    checkboxesNotRequired={false}
                    pageSizeOptions={[10, 25, 50]}
                  />
                </Grid>
              </Grid>
            </TabPanel>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default AddEditIntSolution;
